import { useSearchParams } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { generateAxiosInstanceInstitute } from "../../hooks/useAuthorizedRequestForInstitute";
import { generateAxiosInstanceSection } from "../../hooks/useAuthorizedRequestForSection";
import Select from 'react-select';
import { generateAxiosInstance } from "../../hooks/useAuthorizedRequest";
import { useNavigate } from 'react-router-dom';

const CategoryReport = () => {

    const [filter1, setFilter1] = useState()
    const [filter2, setFilter2] = useState()
    const [filter3, setFilter3] = useState()
    const authorizedAxios = generateAxiosInstance()

    const [gradeList, setGradeList] = useState(null)
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const [divisionSelectList, setSelectDivisionList] = useState(null)
    const [divisionList, setDivisionList] = useState([])
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const [examType, setExamType] = useState()
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
        const apiUrl3 = `/get-exam-master`;
        authorizedAxios && authorizedAxios.get(apiUrl3)
            .then(response => {
                setExamType(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });
    }, [])

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;

        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });
    }

    const handleGradeChange = (e, index) => {

        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });

    }

    useEffect(() => {
        setSelectDivisionList(divisionList?.map((i) => {
            return {
                value: i.id,
                label: i.divisionName
            }
        }))
    }, [divisionList])


    return (
        <>
            {/* <SectionSidebar /> */}
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>

                        <li className="breadcrumb-item active"><span>Category Report</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-person-chalkboard"></i>Category Report</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                            <div className="col-md-6">
                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Exam Type  :</label>
                                                <select class="form-select" aria-label="Default select example" name='test_type_id' 
                                                // onChange={handleInputChange} value={assignExamData.test_type_id}
                                                >
                                                    <option selected value={''} disabled>Select Exam Type</option>
                                                    {
                                                        examType?.map((exam) => {
                                                            return <option value={exam.id}>{exam.examName}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                                {/* <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Exam Type</label>


                                                </div> */}

                                                {/* <div className="col-md-6">
                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                </div>

                                                <div className="col-md-6">
                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division</label>
                                                </div> */}

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='class_id' onChange={handleGradeChange}  >
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }

                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <Select
                                                        // value={divisionSelectList?.filter(option =>
                                                        //     assignExamData.divisions && assignExamData.divisions?.includes(option.value.toString())
                                                        // )}
                                                        isMulti
                                                        name="divisions"
                                                        options={divisionSelectList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Medium"
                                                    // onChange={handleChangeSubjcet}
                                                    // onChange={handleChangeDivision}
                                                    />

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>From Date</label>

                                                    <input type="date" className="form-control" id="result_publish_date" name='result_publish_date' />

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>To Date</label>
                                                    <input type="date" className="form-control" id="result_publish_date" name='result_publish_date' />

                                                </div>



                                            </div>

                                            <div className="row">

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={() => { setFilter1(''); setFilter2(''); setFilter3(''); }}>Reset</button>
                                                    </div>
                                                </div>


                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No</th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">From Date</th>
                                                                        <th scope="col">To Date</th>
                                                                        <th scope="col">Type 1</th>
                                                                        <th scope="col">Type 2</th>
                                                                        <th scope="col">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                {/* <tbody>
                                                                    {
                                                                        teacherList.length > 0 ?
                                                                            teacherList.map((section, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td>{section.teacherName}</td>
                                                                                        <td>{section.email}</td>
                                                                                        <td>{dateFormate(section.joiningDate)}</td>
                                                                                        <td>{dateFormate(section.dob)}</td>
                                                                                        <td>{section.contactNumber}</td>
                                                                                        <td>{section.gender}</td>
                                                                                        <td>{section.qualification}</td>
                                                                                        <td>{section.address}</td>
                                                                                        <td>{section.sectionMasterDetails.sectionName}</td>
                                                                                        <td>
                                                                                         

                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Teacher Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody> */}
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CategoryReport;